export enum ClientCategoryEnum {
    Legal = 1,
    Financial = 2,
    Insurance = 3,
    Corporate = 4,
    ForeignLegal = 5,
    ForeignFinancial = 6,
    ForeignInsurance = 7,
    ForeignCorporate = 8,
}
